export const lessonUses: string[] = [
  'Classroom instruction',
  'Workshop demonstrations',
  'Technical review',
  'Student activities',
  'System explanations',
  'Diagnostic reasoning',
  'Practical application',
  'Assessment preparation',
  'Mixed-level instruction',
]
